import { base } from '@doppio/themes';
import { DripsyProvider } from 'dripsy';
import * as React from 'react';
export const DoppioProvider = ({ applicationName, children, _theme, }) => {
    const theme = _theme ?? base;
    if (_theme) {
        console.error('[doppio] core/DoppioProvider: you should not override `theme` prop! Ping `#core-services-ds-help` channel for help');
    }
    return React.createElement(DripsyProvider, { theme: theme }, children);
};
//# sourceMappingURL=DoppioProvider.js.map